import React, { useCallback, useState } from 'react';

import { UserAddOutlined } from '@ant-design/icons';
import { Button, Col, Select } from 'antd';

import { usePhysicalDeliveryStore } from 'v2/store/PhysicalDelivery';
import { useUserStore } from 'v2/store/User';

interface IProps {
  onRemovePartner: any;
  onAddPartner: any;
  onEdit?: () => void;
}

const Partner: React.FC<IProps> = ({ onRemovePartner, onAddPartner, onEdit }) => {
  const { delivery, setDelivery } = usePhysicalDeliveryStore();
  const [added, setAdded] = useState(false);

  const { user } = useUserStore(({ user }) => ({ user }));

  const handleChange = useCallback(
    (prop: string, value: any) => {
      const updated = { ...delivery, [prop]: value };

      if (prop === 'partner' && !value) {
        setAdded(false);

        if (onRemovePartner) {
          onRemovePartner();
        }
      }

      if (onEdit) {
        onEdit();
      }

      setDelivery(updated);
    },
    [delivery, onRemovePartner, onEdit, setDelivery]
  );

  const onConfirm = useCallback(() => {
    setAdded(true);

    if (onAddPartner) {
      onAddPartner();
    }
  }, [onAddPartner]);

  if (user.email !== 'qa-orbita@eduzz.com') {
    return null;
  }

  return (
    <>
      <Col xs={24} md={16}>
        <label className='mb-1 block text-sm'>Parceiro de logística</label>
        <Select
          id='partner_id'
          className='w-full'
          value={delivery.partner_id}
          onChange={(value: any) => handleChange('partner_id', value)}
          options={[{ label: 'Kapsula Produtos Naturais Ltda', value: 16640004 }]}
        />
      </Col>
      <Col xs={24} md={8} className='md:mt-6'>
        <Button
          block
          type='primary'
          className='mt-6'
          onClick={onConfirm}
          disabled={added || !delivery.partner_id}
          icon={<UserAddOutlined />}
        >
          Adicionar novo parceiro
        </Button>
      </Col>
    </>
  );
};

export default Partner;
